import React, { useState } from "react";
import styles from "./HomePage.module.css";
import "../../../styles/global.css";
import { useNavigate } from "react-router-dom";
import { openCookieSettings } from "../utils/cookieEvents";
import { openPrivacyPolicy } from "../utils/cookieEvents";
import { openCookiesPolicy } from "../utils/cookieEvents";
import CookieBanner from "./CookieBanner";
import CookieSettings from "./CookiesSettings";
import CookiesPolicy from "./CookiesPolicy";
import PrivacyPolicy from "./PrivacyPolicy";

export default function HomePage() {
  const navigate = useNavigate();

  const [cookieSettings, setCookieSettings] = useState({
    analytics: false,
    marketing: false
  });

  return (
    <div className={`darkSectionContent ${styles.fullHeight}`}>
      <div className={styles.contentWrapper}>
        <div className={`${styles.title} ${styles.after}`}>
          <div className={styles.logoItem}>
            <img
              src={`${process.env.PUBLIC_URL}/Images/lightNeutralLogo.webp`}
              alt="Logo"
              className={styles.logo}
            />
          </div>
          <h1>Wybierz rodzaj naszych usług</h1>
        </div>
        <div className={styles.contentSection}>
          <button
            className={styles.buttonSelect}
            onClick={() => navigate("/mechanic")}
          >
            <img
              src={`${process.env.PUBLIC_URL}/Images/mechanic.webp`}
              alt="Mechanik"
              className={styles.image}
            />
            <p className={styles.itemTitle}>Mechnik Nazwa firmy</p>
          </button>
          <button
            className={styles.buttonSelect}
            onClick={() => navigate("/vulcanization")}
          >
            <img
              src={`${process.env.PUBLIC_URL}/Images/vulcanization.webp`}
              alt="Wulkanizacja"
              className={styles.image}
            />
            <p className={styles.itemTitle}>Wulkanizacja Nazwa firmy</p>
          </button>
        </div>
      </div>
      <footer className={styles.footerContent}>
        <div className={styles.secondSectionOfFooter}>
          <p className={styles.sign}>
            &copy; 2026 ArtKoz. Wszelkie prawa zastrzeżone.
          </p>
          <div className={styles.footerButton}>
            <button
              type="button"
              id="setting-cookies"
              className={styles.infoBtn}
              onClick={openCookieSettings}
            >
              Zmień ustawienia cookies
            </button>
            <button
              type="button"
              id="cookies-policy"
              className={styles.infoBtn}
              onClick={openCookiesPolicy}
            >
              Polityka cookies
            </button>
            <button
              type="button"
              id="policy-privacy"
              className={styles.infoBtn}
              onClick={openPrivacyPolicy}
            >
              Polityka prywatności
            </button>
          </div>
        </div>
        <CookieBanner />
        <CookieSettings
          settings={cookieSettings}
          setSettings={setCookieSettings}
        />
        <CookiesPolicy />
        <PrivacyPolicy />
      </footer>
    </div>
  );
}
